import { useQuery } from 'react-query'

import { post, get } from '../../utility/api'
import { ITermsAndConditionsCurrent } from '../../@types/TermsAndConditions'
import { QUERY_KEYS } from '../../config/queryKeys'

const useCurrentTerms = () => {
  return useQuery<ITermsAndConditionsCurrent | null>(
    QUERY_KEYS.termsAndConditions.current,
    ({ signal }) =>
      get('/terms_and_conditions/current', {
        signal,
      }),
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      refetchOnMount: 'always',
    }
  )
}

const acceptTerms = (id: string) => {
  return post('/terms_and_conditions/' + id + '/accept', {})
}

export default {
  getCurrentTerms: useCurrentTerms,
  acceptTerms,
}
